<div  class="col-md-12 card" style="min-height: 100%;" >
                        
    <div class=" row mt-3 " style="padding: 10px;">
   
    
      <div class="col-md-12 " >
        <div class="row">
        <!-- <mat-form-field class=" col-md-3 mt-1 form-group " >
          <input matInput type="text"  [(ngModel)]="supplierSearch.searchText"  placeholder="Search..." autocomplete="off" (input)="searchSupplier()"  >
        
        </mat-form-field>
        <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [length]="totalElements"
        (page)="nextSupplierPage($event)"
        aria-label="Select page">
        </mat-paginator> -->
        
        </div>
        
        <table mat-table
        [dataSource]="dataSource" multiTemplateDataRows style="background-color: transparent;">
       
        <ng-container matColumnDef="source">
         <th mat-header-cell *matHeaderCellDef> Source </th>
         <td mat-cell *matCellDef="let element;" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowClick(element)"> {{ element?.source}} </td>
        </ng-container>
         <!-- <ng-container matColumnDef="name">
           <th mat-header-cell *matHeaderCellDef>Source</th>
           <td mat-cell *matCellDef="let element" > {{element?.source}} </td>
         </ng-container> -->
         <ng-container matColumnDef="bookingType">
          <th mat-header-cell *matHeaderCellDef>Booking Type</th>
          <td mat-cell *matCellDef="let element">
           
            <span *ngIf="element?.bookingType==='I'">International</span>
            <span *ngIf="element?.bookingType==='D'">Domestic</span>
          </td>


        </ng-container>   
        <ng-container matColumnDef="serviceChargeFix">
          <th mat-header-cell *matHeaderCellDef>Service Charge</th>
          <td mat-cell *matCellDef="let element"> {{element?.serviceChargeFix}} </td>
        </ng-container>            
        <!-- <ng-container matColumnDef="status">
         <th mat-header-cell *matHeaderCellDef> Status </th>
         <td mat-cell *matCellDef="let element"> 
          <span *ngIf="element.status==='A'">Active</span>
          <span *ngIf="element.status==='I'">Inactive</span> </td>
        </ng-container> -->
        
        <!-- email Column -->
       
       
       
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDisplay.length">
        <div class="example-element-detail row"
         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        
        </div>
        </td>
        </ng-container>
       
        
        <tr mat-header-row *matHeaderRowDef="columnsDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsDisplay;"
        class="example-element-row">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        <tr class="mat-row" *matNoDataRow>
        <td  class="mat-cell" colspan="4">There is no data in this table</td>
        </tr>
        </table>
        
        
        </div>
        
    
  
  </div> 
  </div>


  <div class="modal" id="myMod" [style.display]="showPopup ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title">
              <h4 *ngIf="action==='new'" class="modal-title">Add Insurance Commercial</h4>
              <h4 *ngIf="action==='update'" class="modal-title">Add Insurance Commercial</h4>

              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()"><span class="hoverCross">&times;</span></button>
              </div>
              <div class="modal-body">
              <div class="col-md-12 mt-3 " *ngIf="showPopup">
                <div class="col-md-12 d-flex justify-content-center" >
                <div class="col-md-12 row " >
                    <div class=" col-md-12 ">
                        <form  [formGroup]="insuranceRegFg"  autocomplete="off"  class=" row" >
                         
                            <mat-form-field  class="col-md-12"  appearance="outline">
                                <mat-label>Type</mat-label>
                               
                                <mat-select matNativeControl   formControlName="bookingType"   name="bookingType"  >
                                    <mat-option value="I">International</mat-option>
                                    <mat-option value="D">Domestic</mat-option>                                  <!-- <mat-option   class="mat-primary" *ngFor="let list of  sourceData"  [value]="list.code" >{{list?.name}} </mat-option> -->
                                </mat-select>
                        
                              </mat-form-field> 
                          <mat-form-field  class="col-md-12"  appearance="outline">
                            <mat-label>Source</mat-label>
                            <mat-select matNativeControl name="source"  formControlName="source"   name="source"  >
                                <mat-option value="Default">Default</mat-option>
                                <mat-option value="nivabupa">Nivabupa</mat-option>
                              <!-- <mat-option   class="mat-primary" *ngFor="let list of  sourceData"  [value]="list.code" >{{list?.name}} </mat-option> -->
                            </mat-select>
                    
                          </mat-form-field> 
                          <mat-form-field class="col-md-12" appearance="outline">
                            <mat-label>Service Charges</mat-label>
                            <input matInput type="text" (keypress)="onlyNumberKey($event)" maxlength="30" name="serviceChargeFix" formControlName="serviceChargeFix" autocomplete="off">
                            <!-- <small *ngIf="insuranceRegFg.controls['serviceChargeFix'].dirty && insuranceRegFg.controls['serviceChargeFix'].invalid" class="warn">Please Enter <S></S>ervice Charge !</small> -->

                          </mat-form-field>
                         
                          
                        
                                                               
                          </form>                               
                    </div>
                    </div>
                    </div>                                      
              </div>
                <div class="modal-footer">
                  <div class="form-group form-inline ">
                    <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                  </div>   
                  <button *ngIf="action==='new'" class="btn btn-outline-success c-width-100px shadow " [disabled]="insuranceRegFg.invalid&&!disable" (click)="AddCommercials()"  >Save</button>
                  <button *ngIf="action==='update'" class="btn btn-outline-success c-width-100px shadow " [disabled]="insuranceRegFg.invalid&&!disable" (click)="UpdateCommercials()"  >Update</button>

                  <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                </div>
              </div>
              </div>
      </div>
  </div>